<script>
const contents = require(`../../../projects/${process.env.PROJECT}/front/content/home.json`)

export default {
  name: 'ContentUtils',
  computed: {
    /**
     * @return {string}
     */
    TITLE () {
      return contents.title
    },

    /**
     * @return {string}
     */
    TOP_LINK_COSA_FARE () {
      return contents.topLinkCosaFare
    },
    /**
     * @return {string}
     */
    TOP_LINK_CAMBIA_ISOLA () {
      return contents.topLinkCambiaIsola
    },

    /**
     * @return {string}
     */
    LOGO_EXTERNAL_1 () {
      return contents.logoExternal1
    },
    /**
     * @return {string}
     */
    LOGO_EXTERNAL_2 () {
      return contents.logoExternal2
    },
    /**
     * @return {string}
     */
    LOGO_EXTERNAL_3 () {
      return contents.logoExternal3
    },

    /**
     * @return {string}
     */
    TOP_LINK_CHI_SIAMO () {
      return contents.topLinkChiSiamo
    },

    /**
     * @return {string}
     */
    TOP_LINK_CHI_SIAMO_URL () {
      return contents.topLinkChiSiamoUrl
    },

    /**
     * @return {string}
     */
    TOP_LINK_AGENZIA () {
      return contents.topLinkAgenzie
    },
    /**
     * @return {string}
     */
    VOLO_HOTEL_ATTIVITA_ENABLED () {
      return contents.voloHotelAttivitaEnabled === 'true'
    },
    /**
     * @return {string}
     */
    VOLO_HOTEL_ATTIVITA_DISABLED_MESSAGE () {
      return contents.voloHotelAttivitaDisabledMessage
    },
    /**
     * @return {string}
     */
    TOUR_ENABLED () {
      return contents.tourEnabled === 'true'
    },
    /**
     * @return {string}
     */
    TOUR_DISABLED_MESSAGE () {
      return contents.tourDisabledMessage
    },
    /**
     * @return {string}
     */
    EXPERIENCE_ENABLED () {
      return contents.experienceEnabled === 'true'
    },
    /**
     * @return {string}
     */
    EXPERIENCE_DISABLED_MESSAGE () {
      return contents.experienceDisabledMessage
    },
    /**
     * @returns {*}
     */
    FORMS_PARAGRAPH () {
      return contents.formsParagraph
    },
    /**
     * @returns {*}
     */
    HOME_STEP1 () {
      return contents.step1Html
    },
    /**
     * @returns {*}
     */
    HOME_STEP2 () {
      return contents.step2Html
    },
    /**
     * @returns {*}
     */
    HOME_STEP3 () {
      return contents.step3Html
    },
    /**
     * @returns {*}
     */
    PRODUCT_NAME1 () {
      return contents.product1Name
    },
    /**
     * @returns {*}
     */
    PRODUCT_DESCRIPTION1 () {
      return contents.product1Description
    },
    /**
     * @returns {*}
     */
    PRODUCT_NAME2 () {
      return contents.product2Name
    },
    /**
     * @returns {*}
     */
    PRODUCT_DESCRIPTION2 () {
      return contents.product2Description
    },
    /**
     * @returns {*}
     */
    PRODUCT_NAME3 () {
      return contents.product3Name
    },
    /**
     * @returns {*}
     */
    PRODUCT_DESCRIPTION3 () {
      return contents.product3Description
    },
    /**
       * @returns {*}
       */
    FORM_NOTE1 () {
      return contents.form1Note
    },
    /**
       * @returns {*}
       */
    FORM_NOTE2 () {
      return contents.form2Note
    },
    /**
       * @returns {*}
       */
    FORM_NOTE3 () {
      return contents.form3Note
    },
    /**
       * @returns {*}
       */
    FORM_DESCRIPTION1 () {
      return contents.form1Description
    },
    /**
       * @returns {*}
       */
    FORM_DESCRIPTION2 () {
      return contents.form2Description
    },
    /**
       * @returns {*}
       */
    FORM_DESCRIPTION3 () {
      return contents.form3Description
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/utils/ContentUtils.vue